import { common, laPayment, mstCommon } from '@libs/domain';
import { mstListSearchFieldConfig, mstRegistrationFieldConfig } from '@libs/templates/mst';
import { Item } from '@ps-smart-cp/ppfw-client';

const leaseCompanyMstRegistrationFieldConfig = {
  ...mstRegistrationFieldConfig,
  eligibleBillingProvider: Item.of(
    common.names.eligibleBillingProvider,
    common.attributes.eligibleBillingProvider,
  ),
  phoneNo: Item.of(common.names.phoneNo, common.attributes.phoneNo),
  paymentDay: Item.of(laPayment.names.paymentDay, laPayment.attributes.paymentDay),
};

const leaseCompanyMstListSearchFieldConfig = {
  ...mstListSearchFieldConfig,
  phoneNo: Item.of(common.names.phoneNo, common.attributes.phoneNo),
  eligibleBillingProviderCondition: Item.of(
    common.names.eligibleBillingProviderCondition,
    common.attributes.eligibleBillingProviderCondition,
  ),
};

const leaseCompanyMstSettingFieldConfig = {
  codeDigits: Item.of(mstCommon.names.codeDigits, mstCommon.attributes.codeDigits),
};

export {
  leaseCompanyMstListSearchFieldConfig,
  leaseCompanyMstRegistrationFieldConfig,
  leaseCompanyMstSettingFieldConfig,
};
